import {SignUpCheckExistence} from 'domain/usecases';
import {RemoteSignUpCheckExistence} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeSignUpCheckExistence = (): SignUpCheckExistence =>
	new RemoteSignUpCheckExistence(
		makeBFFApiUrl(EntryFlowEndPoints.signUpCheckExistence),
		makeAuthorizeHttpClientDecorator(),
	);
